<template>
    <div class="filter-search-form note note-info note-bordered margin-bottom-20">
        <div class="row margin-bottom-20">
            <div class="col-md-9">
                <div class="col-md-7">
                    <div class="col-md-12">
                        <label class="filtro-label-avancado">Tipos</label>
                        <wes-Lookup
                            ref="lookupPerfil"
                            entityName="FN_GERENCIAISPERFIS"
                            resultFields="NOME"
                            whereClauseSessionKey="lookupPerfilGerenciaisWhere"
                            :placeholders="getPlaceHoldersPerfil()"
                            :enabled="isTreeViewLoaded()"
                            v-on:change="selecionarPerfil"
                            v-on:mounted="limparPerfilSelecionado"
                            v-on:clear="limparPerfilSelecionado">
                        </wes-Lookup>
                    </div>
                </div>
                <div @click="actionsClick" class="filtro-gerenciais-right-actions col-md-5" >
                    <label class="filtro-label-avancado">Período</label>
                    <transition name="slide-fade">
                        <span v-if="isDateError" class="badge badge-danger"> Data inicial deve ser menor que data final </span>
                    </transition>
                    <fluxo-caixa-date-range-input
                        :gerarEnabled="isTreeViewLoaded()"
                        :startView="0"
                        buttonDescription="Gerar"
                        v-on:error-input="onErrorDateRange"
                        :startDate="getStartDateValue()"
                        :endDate="getEndDateValue()"
                        v-on:apply="applyFilter"
                    />
                </div>
            </div>
            <div class="col-md-3 filtro-gerenciais-actions collapsible" data-toggle="collapse" data-parent="false" data-target="#filtro-body">
                <div style="padding-top:20px">
				    <p style="font-size:14px; text-align: right;">Filtro avançado <i class="fa fa-chevron-down font-black" style="cursor:pointer;" title="Clique para expandir o menu de filtros."></i></p>
			    </div>
            </div>
        </div>
        <div id="filtro-body" class="row collapse" aria-expanded="false">
            <div class="col-md-3" style="min-height:300px">
                <ul class="nav nav-tabs tabs-left tabbable-line">
                    <li class="active">
                        <a href="#treeview_empresaFilial" data-toggle="tab">
                            <i class="fa fa-building"></i> Empresas <span v-if="(getTotalSelectedEmpresaFilial() > 0) && !isEmpresaTreeViewLoading()" class="badge badge-default"> {{getTotalSelectedEmpresaFilial()}} </span>
                            <transition name="slide-fade">
                                <span v-if="isEmpresaTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                            <transition name="slide-fade">
                                <span v-if="isEmpresaMissing" class="badge badge-danger"> selecione </span>
                            </transition>
                        </a>
                    </li>
                    <li class="pulsate-regular">
                        <a href="#treeview_contas"
                           v-bind:class="{ 'not-active' : (isContaTreeViewLoading() || !isContaEmpresaMestreRegra()) }"
                           data-toggle="tab">
                            <i class="fa fa-bank"></i> Contas <span v-if="(getTotalSelectedContas() > 0) && !isContaTreeViewLoading()" class="badge badge-default"> {{getTotalSelectedContas()}} </span>
                            <transition name="slide-fade">
                                <span v-if="isContaTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_cc"
                           v-bind:class="{ 'not-active' : notActiveCCRules() }"
                           data-toggle="tab">
                            <i class="fa fa-money"></i> CC <span v-if="(getTotalSelectedCC() > 0) && !isCCTreeViewLoading()" class="badge badge-default"> {{getTotalSelectedCC()}} </span>
                            <transition name="slide-fade">
                                <span v-if="isCCTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_projetos"
                           v-bind:class="{ 'not-active' : (isProjetoTreeViewLoading() || !isProjetoEmpresaMestreRegra()) }"
                           data-toggle="tab">
                            <i class="fa fa-line-chart"></i> Projetos <span v-if="(getTotalSelectedProjetos() > 0) && !isProjetoTreeViewLoading()" class="badge badge-default"> {{getTotalSelectedProjetos()}} </span>
                            <transition name="slide-fade">
                                <span v-if="isProjetoTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_avancado" data-toggle="tab">
                            <i class="fa fa-gears"></i> Tipos Gerenciais
                            <transition name="slide-fade">
                                <span v-if="isAbrangenciaMissing" class="badge badge-danger"> selecione </span>
                            </transition>

                        </a>
                    </li>
                    <li>
                        <a href="#treeview_filtro" data-toggle="tab">
                            <i class="fa fa-gear"></i> Filtro avançado
                            <transition name="slide-fade">
                                <span v-if="isAbrangenciaMissing" class="badge badge-danger"> selecione </span>
                            </transition>

                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-md-9">
                <div class="tab-content">
                    <div class="tab-pane active" id="treeview_empresaFilial">
                        <wes-treeview :key="`${chaveUnicaPerfilSelecionado}-1`" :store="getTreeViewEmpresaFilial()" treeview-id="empresaFilial" endpoint="empresasFiliaisPermitidasUsuario" marcar="false" v-on:item-selected="itemSelected($event, tabInfo.empresaFilial)" v-on:loaded="setTotalTreeViews" v-on:unloaded="setUnloadedTreeView"></wes-treeview>
                    </div>
                    <div class="tab-pane fade" id="treeview_contas">
                        <div class="row">
                            <div class="col-md-6">
                                <wes-treeview-select :key="`${chaveUnicaPerfilSelecionado}-2`" ref="treeviewSelectContas" :markAllByDefault="true" :store="getTreeViewContas()" v-on:menu-item-selected="menuItemSelected" treeview-id="contas" :definitions="contaDefinitions" v-on:lookup-item-selected="lookupItemSelected" v-on:item-selected="itemSelected($event, tabInfo.contas)" v-on:tree-view-loaded="setTotalTreeViews" v-on:tree-view-unloaded="setUnloadedTreeView" v-on:lookup-empty="onLookupContasVazio"></wes-treeview-select>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_cc">
                        <transition name="slide-fade">
                            <div class="row" :key="`${chaveUnicaPerfilSelecionado}-5`">
                                <div class="col-md-12">
                                    <div>
                                        <label class="label-title">Exibir lançamentos sem Centros de Custos informados (NI)</label>
                                        <wes-switch :value="getExibirLancamentosSemCCInformado()" v-on:change="exibirLancamentosSemCcInformadoChanged"></wes-switch>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <div class="row">
                            <div class="col-md-6" style="padding-top: 10px">
                                <wes-treeview-select :key="`${chaveUnicaPerfilSelecionado}-3`" ref="treeviewSelectCC" :store="getTreeViewCentroDeCustos()" v-on:menu-item-selected="menuItemSelected" treeview-id="CC" :definitions="ccDefinitions" v-on:lookup-item-selected="lookupItemSelected" v-on:item-selected="itemSelected($event, tabInfo.centroDeCustos)" v-on:tree-view-loaded="setTotalTreeViews" v-on:tree-view-unloaded="setUnloadedTreeView"></wes-treeview-select>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_projetos">
                        <div class="row">
                            <div class="col-md-12">
                                <div id="treeview_projetos_custom">
                                    <div id="treeview_projetos_custom_filtro"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_avancado" style="padding-top: 10px">
                        <div>
                            <a href="javascript:;"
                               class="btn"
                               :class="colorSelected">
                                <i class="fa fa-bar-chart"></i> Previsto x Realizado
                            </a>
                        </div>
                        <hr />
                        <transition-group name="slide-fade">
                            <div v-if="isAbrangenciaEnabled()" key="abrangenciaFilter">
                                <fluxo-caixa-gerencial-filtro-abrangencia :isFilterNotSelected="isAbrangenciaMissing" v-on:filtro-selected="abrangenciaSelected" :colorSelected="colorSelected" :colorDeselected="colorDeselected"></fluxo-caixa-gerencial-filtro-abrangencia>
                            </div>
                            <div v-if="isCategoriaEnabled() && !isPrevistoRealizadoEnabled()" class="row" key="categoriaFilter">
                                <div class="col-md-12">
                                    <fluxo-caixa-gerencial-filtro-categoria-titulo :colorSelected="colorSelected" :colorDeselected="colorDeselected"></fluxo-caixa-gerencial-filtro-categoria-titulo>
                                </div>
                            </div>
                            <div v-if="isTituloEnabled()" class="row" key="tituloFilter">
                                <div vi class="col-md-12">
                                    <fluxo-caixa-gerencial-filtro-titulo :colorSelected="colorSelected" :colorDeselected="colorDeselected"></fluxo-caixa-gerencial-filtro-titulo>
                                </div>
                            </div>
                        </transition-group>
                        <transition name="slide-fade">
                            <div key="comandosPerfil">
                                <hr />
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Nome do perfil</label>
                                            <input type="text" class="form-control" id="nomePerfil" :value="nomePerfil" @input="setNomePerfil">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>&nbsp;</label>
                                            <div class="form-actions">
                                                <a class="btn btn-info" v-on:click.prevent="persistirPerfil()">
                                                    <i class="fa fa-save"></i> {{ isPerfilSistema() ? "Salvar cópia de perfil pré-definido" : "Salvar perfil" }}
                                                </a>
                                                <a class="btn btn-danger" v-if="perfilSelecionado() && !isPerfilSistema()" v-on:click.prevent="excluirPerfil()">
                                                    <i class="fa fa-times"></i> Excluir perfil
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="tab-pane fade" id="treeview_filtro">
                        <div class="col-md-9">
                            <fluxo-caixa-gerencial-filtro-abrangencia-avancado :colorSelected="colorSelected" :colorDeselected="colorDeselected"></fluxo-caixa-gerencial-filtro-abrangencia-avancado>
                            <hr />
                            <div v-for="(item, index) in lookupItems" :key="index">
                                <label class="filtro-label-avancado">{{ item.label }}</label>
                                <wes-lookup-multiple ref="lookup[item.ref]"
                                                    :entityName="item.entityName"
                                                    :resultFields="item.resultFields"
                                                    :placeholders="getPlaceHoldersCustom(item.placeholder)"
                                                    :enabled="isTreeViewLoaded()"
                                                    v-on:change="item.changeMethod"
                                                    v-on:clear="item.clearMethod"
                                                    v-on:mounted="item.clearMethod">
                                </wes-lookup-multiple>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .filtro-gerenciais-actions {
        cursor: pointer !important;
    }

    .filtro-gerenciais-right-actions {
        float: right;
    }
    .img-tab {
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: cover;
    }

    .noUi-target {
        height: 10px
    }

    .gerenciais-font {
        padding: 0;
        margin: 0;
        line-height: 13px;
        color: #9eacb4;
        font-size: 13px;
        font-weight: 400;
    }

    .noUi-horizontal .noUi-handle {
        width: 24px;
        height: 20px;
    }

    .noUi-handle:before, .noUi-handle:after {
        height: 10px;
        width: 1px;
        left: 8px;
        top: 5px;
    }

    .noUi-handle:after {
        left: 14px;
    }

    .portlet-gerenciais-title {
        border-bottom: 1px solid #eee;
        padding: 0;
        margin-bottom: 1px;
        min-height: 41px;
        -webkit-border-radius: 4px 4px 0 0;
        -moz-border-radius: 4px 4px 0 0;
        -ms-border-radius: 4px 4px 0 0;
        -o-border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
    }

    .not-active {
        pointer-events: none;
        cursor: default;
        text-decoration: none;
        color: black;
    }

    .portlet-treeview {
        min-height: 300px;
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
</style>

<script>
    import { mapGetters } from 'vuex';
    import FluxoCaixaGerencialService from "../../services/FluxoCaixaGerencialService";
    import FluxoCaixaDateRangeInput from "./DateRangeInput.vue";

    const disabledMessage = "Aguarde...";

    export default {
        components: { FluxoCaixaDateRangeInput },
        props: ["colorSelected", "colorDeselected"],
        computed: {
            ...mapGetters({ nomePerfil: 'filtro/getNomePerfil'})
        },
        data: function () {
            return {
                chaveUnicaPerfilSelecionado: 0,
                isEmpresaMissing: false,
                isAbrangenciaMissing: false,
                isDateError:false,
                tabInfo: {
                    empresaFilial: { selected: 0, total: 0 },
                    contas: { selected: 0, total: 0 },
                    centroDeCustos: { selected: 0, total: 0 },
                    projetos: { selected: 0, total: 0 }
                },
                contaDefinitions: [
                    {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosgerenciais",
                        treeviewFilterField: "plano",
                        treeviewEntityName: "ct_contasgerenciais"
                    }],
                ccDefinitions: [
                    {
                        caption: "Padrão",
                        lookupEntityName: "",
                        treeviewFilterField: "",
                        treeviewEntityName: "ct_cc"
                    }, {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosccgerenciais",
                        treeviewFilterField: "tipo",
                        treeviewEntityName: "ct_ccgerenciais"
                    }],
                projetoDefinitions: [
                    {
                        caption: "Padrão",
                        lookupEntityName: "",
                        treeviewFilterField: "",
                        treeviewEntityName: "gn_projetos"
                    }, {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosprojetosgerenciais",
                        treeviewFilterField: "tipo",
                        treeviewEntityName: "ct_projetosgerenciais"
                    }],
                lookupItems: [
                    {
                        label: "Pessoas",
                        ref: "Pessoas",
                        entityName: "GN_PESSOAS",
                        resultFields: "NOME",
                        placeholder: "Pessoas",
                        changeMethod: this.selecionarPessoas,
                        clearMethod: this.limparPessoas
                    },
                    {
                        label: "Tipos de documento",
                        ref: "TiposDocumento",
                        entityName: "FN_TIPOSDOCUMENTOS",
                        resultFields: "NOME",
                        placeholder: "tipos de documento",
                        changeMethod: this.selecionarTiposDocumento,
                        clearMethod: this.limparTiposDocumento
                    },
                    {
                        label: "Tipos de cobrança",
                        ref: "TiposCobranca",
                        entityName: "FN_TIPOSCOBRANCAS",
                        resultFields: "NOME",
                        placeholder: "tipos de cobrança",
                        changeMethod: this.selecionarTiposCobranca,
                        clearMethod: this.limparTiposCobranca
                    },
                    {
                        label: "Categorias de cliente",
                        ref: "CategoriasCliente",
                        entityName: "GN_CATEGORIASCLIENTE",
                        resultFields: "NOME",
                        placeholder: "categorias de cliente",
                        changeMethod: this.selecionarCategoriasCliente,
                        clearMethod: this.limparCategoriasCliente
                    },
                    {
                        label: "Categorias de fornecedor",
                        ref: "CategoriasFornecedor",
                        entityName: "GN_CATEGORIASFORNECEDORES",
                        resultFields: "NOME",
                        placeholder: "categorias de fornecedor",
                        changeMethod: this.selecionarCategoriasFornecedor,
                        clearMethod: this.limparCategoriasFornecedor
                    },
                    {
                        label: "Formas de pagamento",
                        ref: "FormasPagamento",
                        entityName: "FN_FORMASPAGAMENTO",
                        resultFields: "NOME",
                        placeholder: "formas de pagamento",
                        changeMethod: this.selecionarFormasPagamento,
                        clearMethod: this.limparFormasPagamento
                    }
                ]
            }
        },
        mounted: function () {
            const { $store } = this;
            $store.commit("treeview/setDefaultBranchAndCompany", { company: $("#CurrentCompany").val(), branch: $("#CurrentBranch").val() });
            FluxoCaixaGerencialService.getSituacaoEmpresaMestre().then(response => {
                $store.commit("treeview/setEmpresasMestreRegras", response.data);
            });
            $store.subscribe((mutation, state) => {
                const { treeviewSelectContas, treeviewSelectCC } = this.$refs;
                if (mutation.type === 'treeview/setSelected') {
                    if (!$store.getters["treeview/getTotalSelectedContas"]) treeviewSelectContas.clear();
                    if (!$store.getters["treeview/getTotalSelectedCC"]) treeviewSelectCC.clear();
                }
            });
        },
        methods: {
            setNomePerfil(event) {
                this.$store.commit("filtro/setNomePerfil", event.target.value);
            },
            selecionarLookupPerfil(perfil) {
                this.$refs.lookupPerfil.select(perfil);
                this.$store.commit('filtro/setHandlePerfilSelecionado', perfil.handle)
            },
            clearPerfil() {
                this.$refs.lookupPerfil.clear();
            },
            isPerfilSistema() {
                return this.$store.getters["filtro/isPerfilSistema"];
            },
            perfilSelecionado() {
                return this.$store.getters["filtro/getHandlePerfilSelecionado"] > 0;
            },
            excluirPerfil() {
                FluxoCaixaGerencialService.deletePerfilGerenciais(this.$store.getters["filtro/getHandlePerfilSelecionado"])
                    .then((response) => {
                    this.$store.commit("filtro/setNomePerfil", null);
                    this.clearPerfil();
                    toastr.success(response.data);
                });
            },
            persistirPerfil() {
                if (!this.nomePerfil) {
                    toastr.error("Para salvar uma configuração, informe o nome do perfil desejado.");
                    return;
                }

                if (!this.isApplyEnabled())
                    return;

                var gerenciaisFiltroDTO = {
                    filtro: this.$store.state.filtro,
                    treeview: this.$store.state.treeview.treeview_selecoes.map(
                    (selecao) => { return { origem: selecao.origem, tipo: selecao.tipo, selected: selecao.selected }}
                    )
                };

                FluxoCaixaGerencialService.postPerfilGerenciais(gerenciaisFiltroDTO).then((response) => {
                    if (response.data.handlePerfil !== this.$store.state.filtro.handlehandlePerfilSelecionado)
                        this.selecionarLookupPerfil({
                            handle: response.data.handlePerfil,
                            nome: gerenciaisFiltroDTO.filtro.nomePerfil
                        });

                    toastr.success(response.data.mensagemRetorno);
                });
            },
            selecionarPerfil(handlePerfil) {
                this.$store.commit('filtro/setHandlePerfilSelecionado', handlePerfil);

                FluxoCaixaGerencialService.getPerfilGerenciais(handlePerfil).then((response) => {
                    this.$store.commit('treeview/setFromPerfil', response.data.treeview);
                    this.$store.commit('filtro/loadPerfil', response.data.filtro);
                    this.chaveUnicaPerfilSelecionado++;
                });
            },
            limparPerfilSelecionado() {
                // Reset COMPLETO do filtro. Sem isso, os filtros que vieram do
                // perfil carregado (pessoas, tipos de cobrança, formas de pagamento,
                // etc.) ficavam no Vuex mesmo após o usuário "limpar" o perfil —
                // a UI dos lookups mostrava vazio, mas o request enviado ao legacy
                // ainda continha esses filtros, causando comportamento errático
                // (ex: 2.02 Saídas sumiam porque uma pessoa fantasma filtrava
                // documentos). Vide commit 2026-05-11.
                this.$store.commit('filtro/resetFiltros');
                // Incrementa a chave única pra forçar re-render dos componentes
                // filhos (treeviews, lookups) e refletir o reset visualmente.
                this.chaveUnicaPerfilSelecionado++;
            },
            getPlaceHoldersPerfil() {
                return { enabled: "Carregar configurações pré-definidas", disabled: disabledMessage };
            },
            getPlaceHoldersCustom(custom) {
                return { enabled: "Selecionar " + custom, disabled: disabledMessage };
            },
            getTitle(title) {
                return title;
            },
            isContaEmpresaMestreRegra() {
                return this.$store.getters["treeview/isContaMestreEnabled"];
            },
            notActiveCCRules() {
                return (this.isCCTreeViewLoading() || !this.isCCEmpresaMestreRegra());
            },
            isCCEmpresaMestreRegra() {
                return this.$store.getters["treeview/isCCMestreEnabled"];
            },
            isProjetoEmpresaMestreRegra() {
                return this.$store.getters["treeview/isProjetoMestreEnabled"];
            },
            getTreeViewContas() {
                return this.$store.getters["treeview/getContas"]
            },
            getTreeViewProjetos() {
                return this.$store.getters["treeview/getProjetos"];
            },
            getTreeViewCentroDeCustos() {
                return this.$store.getters["treeview/getCentroDeCustos"];
            },
            getTreeViewEmpresaFilial() {
                return this.$store.getters["treeview/getEmpresaFilial"];
            },

            getTotalSelectedContas(choice) {
                return this.$store.getters["treeview/getTotalSelectedContas"];
            },
            getTotalSelectedProjetos(choice) {
                return this.$store.getters["treeview/getTotalSelectedProjetos"];
            },
            getTotalSelectedEmpresaFilial(choice) {
                return this.$store.getters["treeview/getTotalSelectedEmpresaFilial"];
            },
            getTotalSelectedCC(){
                return this.$store.getters["treeview/getTotalSelectedCC"];
            },
            getTreeViewSelectStore() {
                return this.$store.state.treeview;
            },
            actionsClick: function (e) {
                e.stopPropagation();
                return e.preventDefault(); //Para o widget de filtro não ficar expandindo/recolhendo a cada clique.
            },
            // Traduz a falha da consulta para uma mensagem acionável. Antes havia um texto
            // único apontando para sessão/logout, o que desorientava no caso mais comum
            // (524/504 = a consulta estourou o tempo do gateway) e gerava chamado indevido.
            montarMensagemErro: function (response) {
                // Erro de negócio devolvido pelo servidor: mostra o texto como veio.
                if (response && typeof response.data === 'string' && response.data)
                    return response.data;

                var status = response ? response.status : 0;

                // 524 (Cloudflare) e 504: o servidor não respondeu dentro do limite do gateway.
                // status 0 = conexão interrompida/rede, que na prática tem a mesma ação.
                if (status === 524 || status === 504 || !status)
                    return 'A consulta demorou mais que o tempo limite e foi interrompida. '
                         + 'Reduza o período, o número de empresas/filiais ou desmarque opções de detalhamento e tente novamente.';

                if (status === 401 || status === 403)
                    return 'Sua sessão expirou ou você não tem permissão para esta consulta. '
                         + 'Faça logout e login novamente; se persistir, contate o suporte.';

                return 'Erro ao buscar dados. Tente novamente; se persistir, contate o suporte. Status: ' + status;
            },
            getStartDateValue() {
                var val = this.$store.state.options.startDate;
                if (!val) return null;
                var m = moment(val, 'YYYY-MM-DD', true);
                return m.isValid() ? m.toDate() : null;
            },
            getEndDateValue() {
                var val = this.$store.state.options.endDate;
                if (!val) return null;
                var m = moment(val, 'YYYY-MM-DD', true);
                return m.isValid() ? m.toDate() : null;
            },
            applyFilter(args) {
                this.isDateError = false;
                if (!this.isApplyEnabled())
                    return;

                try {
                    this.montarEGerar(args);
                } catch (erro) {
                    // Falha ao MONTAR o filtro (antes de qualquer requisicao). Sem este
                    // catch a excecao morria no handler de evento do Vue: o clique em
                    // "Gerar" nao disparava a chamada, nao mostrava o blockUI e nao exibia
                    // mensagem nenhuma - a tela simplesmente nao reagia.
                    console.error('FluxoCaixaGerencial: falha ao montar o filtro para gerar.', erro);
                    toastr.error('Não foi possível montar o filtro para gerar o fluxo de caixa. Detalhe: '
                        + ((erro && erro.message) ? erro.message : erro));
                }
            },
            montarEGerar(args) {
                var fmtDate = function(d) {
                    if (!d || isNaN(d.getTime())) return '';
                    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
                };
                this.$store.commit("options/setStartDate", fmtDate(args.start));
                this.$store.commit("options/setEndDate", fmtDate(args.end));

                // Leitura DEFENSIVA dos widgets de Projetos: eles moram no .aspx
                // (#tipo_projeto, os SimpleGrid PROJETOS/PROJETOS_GERENCIAIS e o
                // FilterWidget de planos gerenciais) e podem nao estar renderizados -
                // entity view ausente, sem permissao, ou o indice ctlNN do controle do
                // filtro mudando de posicao. Com o acesso direto ([0].value) qualquer
                // uma dessas ausencias lancava TypeError e matava o "Gerar" em silencio.
                var _tipoProjeto = $('#tipo_projeto').val() || 'padrao';

                var _gridProjetos = _tipoProjeto == 'padrao'
                    ? '#ctl00_Main_PROJETOS_SimpleGrid'
                    : '#ctl00_Main_PROJETOS_GERENCIAIS_SimpleGrid';

                const _projetos = $(_gridProjetos + ' :checkbox:checked').toArray()
                    .filter(proj => proj.value > 0)
                    .map(e => $(e).closest('[handle]').attr('handle'))
                    .filter(handle => !!handle);

                const _planoGerencial = $('#ctl00_Main_FILTRO_PROJETOS_GERENCIAIS_FilterControl_GERAL_ctl06_ctl01_select').val() || '';

                var formatarDataLocal = function (d) {
                    var y = d.getFullYear();
                    var m = ('0' + (d.getMonth() + 1)).slice(-2);
                    var dia = ('0' + d.getDate()).slice(-2);
                    return y + '-' + m + '-' + dia;
                };
                var data = {
                    treeview: this.$store.state.treeview.treeview_selecoes.filter(x=>x.id != "projetos" && x.data != 0),
                    filtro: this.$store.state.filtro,
                    startDate: formatarDataLocal(args.start),
                    endDate: formatarDataLocal(args.end),
                    projetos: {
                        tipoProjeto: _tipoProjeto,
                        projetos: _projetos,
                        planoGerencial: _planoGerencial
                    }
                };


                window.$("#filtro-body").collapse("hide");
                this.$store.commit('pivotgrid/beginRequest');

                // Uma requisicao so (pivot + saldos). Ver comentario da rota unificada
                // em FluxoCaixaGerencialService.js: em paralelo elas serializavam no
                // lock de sessao do WES e as duas estouravam o limite do gateway.
                FluxoCaixaGerencialService.getFluxoCaixaGerencialPivotGridComSaldos(data).then(function(response) {
                    var payload = response.data.gerenciais;

                    if (!payload.dataSet || payload.dataSet.length === 0)
                        window.$("#filtro-body").collapse("show");

                    payload.dataSetSaldosBancarios = response.data.saldosBancarios;

                    this.$store.commit('pivotgrid/endRequestSuccess', payload);

                }.bind(this), function(response) {
                    window.$("#filtro-body").collapse("show");

                    this.$store.commit('pivotgrid/endRequestError', this.montarMensagemErro(response));

                }.bind(this));
            },
            isApplyEnabled() {
                var result = true;
                var rules = [this.checkFiltroAbrangencia(), this.checkFiltroEmpresa()];
                for(var i in rules) {
                    var current = rules[i];
                    if(!current.condition()) {
                        current.showErrorMessage();
                        result = false;
                        break;
                    }
                }
                return result;
            },
            checkFiltroEmpresa() {
                var result = {
                    condition: this.isEmpresaSelected,
                    showErrorMessage: this.showEmpresaNotSelectedMessage
                }
                return result;
            },
            checkFiltroAbrangencia() {
                var result = {
                    condition: this.isFilterAbrangenciaSelected,
                    showErrorMessage: this.showFilterNotSelectedMessage
                }
                return result;
            },
            showEmpresaNotSelectedMessage() {
                toastr.error("É necessário selecionar uma empresa para aplicar o filtro.");
                this.isEmpresaMissing = true;
            },
            isEmpresaSelected() {
                var r = this.$store.getters["treeview/isEmpresaSelected"];
                return r;
            },
            showFilterNotSelectedMessage() {
                toastr.error("É necessário escolher um tipo de abrangência(filtro, devolucoes...)")
                this.isAbrangenciaMissing = true;
                return "ok";
            },
            isEmpresaTreeViewLoading() {
                return this.$store.getters["treeview/isEmpresaTreeviewLoading"];
            },
            isContaTreeViewLoading() {
                return this.$store.getters["treeview/isContaTreeviewLoading"];
            },
            isCCTreeViewLoading() {
                return this.$store.getters["treeview/isCCTreeviewLoading"];
            },
            isProjetoTreeViewLoading() {
                return this.$store.getters["treeview/isProjetoTreeviewLoading"];
            },
            isFilterAbrangenciaSelected() {
                return this.$store.getters["filtro/isAplicarEnabled"];
            },
            isAbrangenciaEnabled() {
                return this.$store.getters["filtro/isAbrangenciaEnabled"]
            },
            isTipoCalculoEnabled(tipoCalculo) {
                return this.$store.state.filtro.tipoCalculo === tipoCalculo;
            },
            selectAbrangencia(tipoCalculo) {
                this.$store.commit('filtro/setTipoCalculo', tipoCalculo);
            },
            itemSelected: function (args, tabInfo) {
                var payload = {
                    choice: args.id,
                    selected: args.selected
                };
                if(payload.choice === "empresaFilial"){
                    this.isEmpresaMissing = false;
                }
                this.$store.commit('treeview/setSelected', payload);
                tabInfo.selected = args.selected.length;
            },
            setUnloadedTreeView: function(payload){
                this.$store.commit('treeview/setLoad', payload);
            },
            onLookupContasVazio: function () {
                // Disparado quando não há nenhum plano gerencial cadastrado: o treeview
                // de contas é destravado (deixa de carregar infinitamente) e o usuário
                // é avisado para cadastrar um plano gerencial.
                toastr.warning("Não há plano gerencial cadastrado. Cadastre um plano gerencial para filtrar as contas.");
            },
            setTotalTreeViews: function (payload) {
                this.$store.commit('treeview/setLoad', { choice: payload.choice, loaded: true });
                this.$store.commit('treeview/setData', payload);
            },
            isTreeViewLoaded : function() {
                return this.$store.getters["treeview/isAllTreeviewLoaded"];
            },
            isTituloEnabled() {
                return this.$store.getters["filtro/isFiltroTituloEnabled"];
            },
            isCategoriaEnabled() {
                return this.$store.getters["filtro/isFiltroCategoriaEnabled"];
            },
            analiticoSwitchChanged(event, state) {
                this.$store.commit('filtro/changeAnalitico');
            },
            exibirLancamentosSemCcInformadoChanged(event, state) {
                this.$store.commit('filtro/changeExibirLancamentosSemCcInformado');
            },
            exibirLancamentosSemProjetoInformadoChanged(event, state) {
                this.$store.commit('filtro/changeExibirLancamentosSemProjetoInformado');
            },
            getAnalitico() {
                return this.$store.state.filtro.analitico;
            },
            getDocumentoEmAberto() {
                return this.$store.state.filtro.documentoEmAberto;
            },
            getExibirLancamentosSemCCInformado() {
                return this.$store.state.filtro.exibirLancamentosSemCcInformado;
            },
            getExibirLancamentosSemProjetoInformado() {
                return this.$store.state.filtro.exibirLancamentosSemProjetoInformado;
            },
            lookupItemSelected(payload) {
                this.$store.commit('treeview/setOrigem', payload);
            },
            selecionarPessoas(payload) {
                this.$store.commit('filtro/setPessoaHandleSelecionados', payload);
            },
            limparPessoas() {
                this.$store.commit('filtro/setPessoaHandleSelecionados', []);
            },
            selecionarTiposDocumento(payload) {
                this.$store.commit('filtro/setTipoDocumentoHandleSelecionados', payload);
            },
            limparTiposDocumento() {
                this.$store.commit('filtro/setTipoDocumentoHandleSelecionados', []);
            },
            selecionarTiposCobranca(payload) {
                this.$store.commit('filtro/setTipoCobrancaHandleSelecionados', payload);
            },
            limparTiposCobranca() {
                this.$store.commit('filtro/setTipoCobrancaHandleSelecionados', []);
            },
            selecionarCategoriasCliente(payload) {
                this.$store.commit('filtro/setCategoriaClienteHandleSelecionados', payload);
            },
            limparCategoriasCliente() {
                this.$store.commit('filtro/setCategoriaClienteHandleSelecionados', []);
            },
            selecionarCategoriasFornecedor(payload) {
                this.$store.commit('filtro/setCategoriaFornecedorHandleSelecionados', payload);
            },
            limparCategoriasFornecedor() {
                this.$store.commit('filtro/setCategoriaFornecedorHandleSelecionados', []);
            },
            selecionarFormasPagamento(payload) {
                this.$store.commit('filtro/setFormaPagamentoHandleSelecionados', payload);
            },
            limparFormasPagamento() {
                this.$store.commit('filtro/setFormaPagamentoHandleSelecionados', []);
            },
            menuItemSelected(payload) {
                this.$store.commit('treeview/setTipo', payload);
            },
            abrangenciaSelected(payload) {
                this.isAbrangenciaMissing = false;
            },
            empresaSelected(payload) {
                this.isEmpresaMissing = false;
            },
            onErrorDateRange(payload) {
                toastr.error("A data inicial deve ser maior que a data final.");
                this.isDateError = true;
            },
            isPrevistoRealizadoEnabled() {
                return this.$store.getters["filtro/isPrevistoRealizado"];
            },
            togglePrevistoRealizado() {
                this.$store.commit('filtro/togglePrevistoRealizado');
            },
            isAgrupaPorTipoContaEnabled() {
                return this.$store.getters["pivotgrid/isAgrupaPorTipoConta"];
            },
            toggleAgrupaPorTipoConta() {
                this.$store.commit('pivotgrid/toggleAgrupaPorTipoConta');
            }
        }
    }
//# sourceURL=settings.vue
</script>
